var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { observable, action, computed } from 'mobx';
import { serializable, object, list } from 'serializr';
import path from 'path';
import { homedir } from 'os';
import EditorStore from './EditorStore';
import SectionStore from './SectionStore';
export default class EditorWorkspacesStore extends SectionStore {
    constructor() {
        super('Editor Workspaces', 'fa fa-edit');
        if ('true' === process.env.TARGET_ELECTRON) {
            this.rootDir = path.join(homedir(), '.greycat');
        }
        else {
            this.rootDir = 'fake:///';
        }
        this.isSelectDirOpen = true;
        this.workspaces = [];
    }
    createWorkspace(name) {
        const editor = this.workspaces.find((ws) => ws.name === name);
        if (!editor) {
            this.workspaces.push(new EditorStore(name));
        }
    }
    changeWorkspace(ws) {
        this.workspaces.forEach((e) => e.isActive = false);
        ws.isActive = true;
    }
    deleteWorkspace(ws) {
        const wsIndex = this.workspaces.findIndex(({ name }) => name === ws.name);
        this.workspaces.splice(wsIndex, 1);
    }
    update() {
        if (this.selectedDir) {
            this.rootDir = this.selectedDir;
            if ('true' === process.env.TARGET_ELECTRON) {
                const { ipcRenderer } = require('electron');
                const { WS_LOAD } = require('../../common/commands');
                ipcRenderer.send(WS_LOAD, this.rootDir);
                this.selectedDir = undefined;
            }
        }
        this.hideSelectDir();
    }
    showSelectDir() {
        this.isSelectDirOpen = true;
    }
    hideSelectDir() {
        this.isSelectDirOpen = false;
    }
    get current() {
        return this.workspaces.find((e) => e.isActive);
    }
}
__decorate([
    observable, serializable,
    __metadata("design:type", String)
], EditorWorkspacesStore.prototype, "rootDir", void 0);
__decorate([
    observable, serializable,
    __metadata("design:type", Boolean)
], EditorWorkspacesStore.prototype, "isSelectDirOpen", void 0);
__decorate([
    observable, serializable(list(object(EditorStore))),
    __metadata("design:type", Array)
], EditorWorkspacesStore.prototype, "workspaces", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], EditorWorkspacesStore.prototype, "selectedDir", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], EditorWorkspacesStore.prototype, "createWorkspace", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_a = typeof EditorStore !== "undefined" && EditorStore) === "function" ? _a : Object]),
    __metadata("design:returntype", void 0)
], EditorWorkspacesStore.prototype, "changeWorkspace", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_b = typeof EditorStore !== "undefined" && EditorStore) === "function" ? _b : Object]),
    __metadata("design:returntype", void 0)
], EditorWorkspacesStore.prototype, "deleteWorkspace", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], EditorWorkspacesStore.prototype, "update", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], EditorWorkspacesStore.prototype, "showSelectDir", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], EditorWorkspacesStore.prototype, "hideSelectDir", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], EditorWorkspacesStore.prototype, "current", null);
